import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const ReadyToEnter = () => {
  return (
    <section
      className="bg-gray-900 text-white py-20 sm:py-28"
      data-testid="ready-to-enter-section"
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white mb-6">
          Ready to Enter?
        </h2>
        <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto mb-8">
          Choose your category and submit your best exhibition stand design.
        </p>
        
        <Link to="/apply">
          <Button
            className="bg-amber-500 hover:bg-amber-600 text-black font-bold px-8 py-6 text-lg rounded-[10px] shadow-lg hover:shadow-xl transition-all duration-200 inline-flex items-center gap-2"
            data-testid="start-application-button"
          >
            Start Your Application
            <ArrowRight className="h-5 w-5" />
          </Button>
        </Link>

        <p className="mt-8 text-sm text-gray-400">
          Deadline: June 10, 2026
        </p>
      </div>
    </section>
  );
};